/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { ICustomTheme } from 'interfaces';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { challengeSelector } from 'reducers/challenge.reducer';
import { getSelectedProducts } from '../utils';
import { StepsType, IForm } from '../interfaces';
import { STEPS } from '../constants';
import { NavButtons } from './NavButtons';
import { NbOfResultsChip } from './NbOfResultsChip';
import { StyledContainer } from './styles';
import {
  StyledArrowUpIcon,
  StyledSecondaryNavButton,
} from './NavButtons/styles';

export default function DeclarationNavigation({
  step,
  scrollTop,
}: {
  step: StepsType;
  scrollTop?: () => void;
}): JSX.Element {
  const { values } = useFormikContext<IForm>();
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { id: challengeIdString }: { id: string } = useParams();
  const challengeId = Number(challengeIdString);
  const { data: challengeData } = useSelector(challengeSelector(challengeId));
  const hasResultEntryEnabled = challengeData?.resultEntryEnabled;

  const selectedProducts = getSelectedProducts(values[STEPS.products]);

  return (
    <StyledContainer
      isMobile={isMobile}
      hasResultEntryEnabled={hasResultEntryEnabled}
    >
      {isMobile && (step === STEPS.products || step === STEPS.summary) && (
        <StyledSecondaryNavButton
          onClick={scrollTop}
          variant="contained"
          type="button"
          disableElevation
          backgroundColor={theme.colors.paletteFromBO.main}
          isMobile={isMobile}
        >
          <StyledArrowUpIcon />
        </StyledSecondaryNavButton>
      )}
      {isMobile && hasResultEntryEnabled && (
        <NbOfResultsChip selectedProducts={selectedProducts} />
      )}
      <NavButtons
        step={step}
        selectedProducts={selectedProducts}
        scrollTop={scrollTop}
        challengeData={challengeData}
      />
      {!isMobile && hasResultEntryEnabled && (
        <NbOfResultsChip selectedProducts={selectedProducts} />
      )}
      {!isMobile && (step === STEPS.products || step === STEPS.summary) && (
        <StyledSecondaryNavButton
          onClick={scrollTop}
          variant="contained"
          type="button"
          disableElevation
          backgroundColor={theme.colors.paletteFromBO.main}
          isMobile={isMobile}
        >
          <StyledArrowUpIcon />
        </StyledSecondaryNavButton>
      )}
    </StyledContainer>
  );
}
